export enum ProjectTypeEnum {
  Superbog = 'Superbog',
  SuperReader = 'SuperReader',
  Fagportal = 'Fagportal',
  HDBHDW = 'HDBHDW',
  PS = 'PS',
  PrintBar = 'PrintBar',
  Other = 'Andet',
}
